<app-notification-card
  [iconName]="isMulti() ? 'checklist' : 'radio_button_checked'"
  [title]="isMulti() ? 'Select Options' : 'Choose an Option'">
  @if (state() === 'resolved') {
    <span notifBadge class="notification-badge mat-font-label-sm notification-badge--success">
      <mat-icon>check_circle</mat-icon>
      Submitted
    </span>
  }
  @if (state() === 'expired') {
    <span notifBadge class="notification-badge mat-font-label-sm notification-badge--pending">
      <mat-icon>timer_off</mat-icon>
      Expired
    </span>
  }
  <!-- Engine-stamped ask context lives inside the card header while pending (HITL contract §2) -->
  @if (state() === 'pending') {
    <app-hitl-ask-context notifBadge [entry]="entry()" />
  }

  <!-- Prompt -->
  <p class="mat-font-body-md mb-0">{{ entry().display_text }}</p>

  <!-- Single select -->
  @if (state() === 'pending' && !isMulti()) {
    <mat-radio-group class="d-flex flex-column gap-1" (change)="selectOne($event.value)">
      @for (opt of entry().options; track opt.id) {
        <mat-radio-button [value]="opt.id" [matTooltip]="tooltipFor(opt.id) ?? ''">{{ opt.label }}</mat-radio-button>
      }
    </mat-radio-group>
  }

  <!-- Multi select -->
  @if (state() === 'pending' && isMulti()) {
    <div class="d-flex flex-column gap-1">
      @for (opt of entry().options; track opt.id) {
        <mat-checkbox [value]="opt.id" [matTooltip]="tooltipFor(opt.id) ?? ''" (change)="toggleMultiId(opt.id)">{{ opt.label }}</mat-checkbox>
      }
    </div>
    <div>
      <button matButton [disabled]="!canConfirm()" (click)="confirmMulti()">
        <mat-icon>check</mat-icon>
        Confirm selection
      </button>
    </div>
  }

  <!-- Resolved -->
  @if (state() === 'resolved') {
    <div class="d-flex flex-wrap gap-1">
      @for (label of resolvedLabels(); track label) {
        <span class="hitl-resolved-label mat-font-body-sm">{{ label }}</span>
      }
    </div>
  }

  <!-- Expired -->
  @if (state() === 'expired') {
    <div class="d-flex flex-column gap-2">
      <p class="mat-font-body-sm mb-0 mat-text-on-surface-variant">This request has expired. Click Restart to try again.</p>
      <div>
        <button matButton="outlined" (click)="restart()">
          <mat-icon>refresh</mat-icon>
          Restart
        </button>
      </div>
    </div>
  }
</app-notification-card>
